import { Reveal, Eyebrow } from "@/components/Reveal";

const ABOUT_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_brand-embodied/artifacts/4ca19792e4662e58_Screenshot%202026-10-07%20at%202.35.23%E2%80%AFPM.png";

const TEACHING_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_brand-embodied/artifacts/cc906d95b945cdbe_Screenshot%202026-10-07%20at%202.34.48%E2%80%AFPM.png";

const STATS = [
  { value: "227K", label: "Instagram followers" },
  { value: "150K+", label: "followers added in 4 months" },
  { value: "$20–30K", label: "Dani's own monthly revenue" },
  { value: "8", label: "weeks of focused work" },
];

export const About = () => (
  <section id="about" className="bg-bone py-24 lg:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-10">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-md">
            <div className="overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Portrait of Dani Gutierrez"
                data-testid="about-portrait"
                className="img-bw aspect-[4/5] w-full object-cover"
              />
            </div>
            <img
              src={TEACHING_IMG}
              alt="Dani Gutierrez teaching a live session"
              data-testid="about-teaching"
              className="img-bw absolute -right-8 bottom-6 hidden w-1/2 border-4 border-bone object-cover shadow-2xl sm:block aspect-[3/4]"
            />
            <div className="absolute -bottom-px -right-px h-10 w-10 border-b-2 border-r-2 border-forest" />
            <p className="mt-6 font-serif text-sm italic text-stone">
              Dani Gutierrez — founder, The Embodied Creator
            </p>
          </div>
        </Reveal>

        <div className="lg:col-span-7 lg:pl-10">
          <Reveal>
            <Eyebrow light>Meet your mentor</Eyebrow>
            <h2 className="mt-6 font-mont text-3xl font-bold leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Built in public.
              <br />
              <em className="italic text-forest">Taught</em> in person.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 max-w-xl space-y-5 text-base leading-relaxed text-[#5c5c5c]">
              <p>
                <strong className="font-bold text-ink">Dani Gutierrez</strong>{" "}
                is a creator and mentor with a community of{" "}
                <strong className="font-medium text-ink">227,000</strong> on
                Instagram. In four months he grew his audience by{" "}
                <strong className="font-medium text-ink">150,000+</strong>{" "}
                people and built his business to consistent{" "}
                <strong className="font-medium text-ink">$20–30k months</strong>{" "}
                — his numbers, earned in the open, one post at a time.
              </p>
              <p>
                The Embodied Creator is the method behind that growth: a brand
                built with intention, an offer people actually want, and sales
                conversations that feel like service. Taught in a small group,
                at a pace you can hold.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <div className="mt-12 grid grid-cols-2 border-t border-ink/10">
              {STATS.map((s, i) => (
                <div
                  key={i}
                  className="border-b border-ink/10 py-7 pr-6 sm:pr-10"
                >
                  <p className="font-mont text-2xl font-bold text-ink sm:text-3xl">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.18em] text-stone">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs text-stone">
              Dani&rsquo;s results are shared as context, not as a promise of
              what you&rsquo;ll earn.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default About;
